export default {
  id: 214,
  title: 'Target #214 - Newspaper',
  url: 'https://cssbattle.dev/play/214',
  colors: ['#F8F8F8', '#787885'],
  solution:
    '<p a><p b><p c><style>p[a],p[b]{left:30;background:#787885}p[a],p[b],p[c]{background:#787885}body{background:#f8f8f8}p{position:fixed;margin:0}p[a]{top:20;width:40;height:50;box-shadow:60px 0 #787885,120px 0 #787885,180px 0 #787885,240px 0 #787885,300px 0 #787885}p[b]{top:80;width:340;height:10;box-shadow:0 30px #787885,0 50px #787885,0 70px #787885,0 90px #787885,0 110px #787885,0 130px #787885,0 150px #787885,0 170px #787885,0 190px #787885}p[c]{top:120;left:104;width:172;height:150;border:10px solid #f8f8f8',
}
